<div class="row">
  <nav class="navbar navbar-fixed-top" role="navigation">
    <div class="navbar-header">
      <button pButton (click)="toggleNavigation()" type="button" icon="fa fa-bars" class="p-button secondary-button"
        iconPos="left" tabindex="999"></button>
      <plyca-helpIndex></plyca-helpIndex>
      <button (click)="logout()" type="button" class="btn secondary-outline-button p-0 float-right" tabindex="1004">
        <i class="fas fa-power-off fa-2x" aria-hidden="true"></i>
        <span class="sm-hidden"> {{ 'Navigation.exit.text' | translate }}</span>
      </button>
      <button (click)="prefs()" type="button" class="btn secondary-outline-button p-0 float-right m-r-sm"
        tabindex="1003" aria-label="this.translate.instant('UserPrefs.user.pref.option')">
        <i class="fas fa-user-cog fa-2x" aria-hidden="true"></i>
      </button>
      <plyca-contextHelp class="float-right m-r-sm"></plyca-contextHelp>
    </div>
  </nav>
</div>